import { cloneElement } from 'react'
import styled from 'styled-components'

import { CloseIcon } from '@10xLabs/react-web/components/Icons/Close'
import { ClickAwayListener } from '@10xLabs/react-web/components/ClickAwayListener'
import { device } from 'utils/style'

const StyledWrapper = styled.div<TSFixMe>`
  @media ${device.tablet} {
    position: relative;
  }
`

const Wrapper = (props: TSFixMe): TSFixMe => {
  const toggle = (): TSFixMe => {
    props.setOpen(!props.isOpen)
  }

  const handleClickOutside = (): TSFixMe => {
    props.setOpen(false)
  }

  const children = [
    cloneElement(props.children[0], {
      key: 'toggle',
      onClick: toggle
    }),
    cloneElement(props.children[1], {
      key: 'content',
      isOpen: props.isOpen
    })
  ]

  return (
    <ClickAwayListener onClickAway={handleClickOutside}>
      <StyledWrapper>{children}</StyledWrapper>
    </ClickAwayListener>
  )
}

const CloseWrapper = styled.div<TSFixMe>`
  display: inline-block;

  ${(props): TSFixMe => {
    if (props.isBlock) {
      return `
        padding: 10px;
      `
    }

    return `
      position: absolute;
      top: 7px;
      left: 10px;
    `
  }}

  @media ${device.tablet} {
    display: none;
  }
`

const CloseContainer = styled.div<TSFixMe>`
  display: flex;
`

const Close = (props: TSFixMe): TSFixMe => {
  return (
    <CloseWrapper isBlock={props.isBlock}>
      <CloseContainer onClick={props.onClick}>
        <CloseIcon />
      </CloseContainer>
    </CloseWrapper>
  )
}

const Toggle = (props: TSFixMe): TSFixMe => {
  return <div {...props}>{props.children}</div>
}

const StyledContent = styled.div<TSFixMe>`
  position: fixed;
  background-color: white;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 100;

  @media ${device.tablet} {
    position: absolute;
    top: -5px;
    left: -10px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    width: ${(props): TSFixMe => (props.autoWidth ? 'auto' : 'calc(100% + 20px)')};
    min-width: 300px;
    height: auto;
    height: initial;
    margin-bottom: 20px;
  }
`

const Content = ({ isOpen, children, ...props }: TSFixMe): TSFixMe => {
  if (!isOpen) return null

  return <StyledContent {...props}>{children}</StyledContent>
}

export default {
  Wrapper,
  Close,
  Toggle,
  Content
}
